import React, { useEffect, useState } from "react";
import { BiRevision } from "react-icons/bi";
import { ClientChart } from "../../components/ClientChart";
import { LastLogs } from "../../components/LastLogs";
import { MessagesCountBar } from "../../components/MessagesCountBar";
import { api } from "../../services/api";
import { Page } from "./styles";
import { IClient } from '../Clients'
import { message } from "antd";
import { Load } from "../../components/Load";
import { Empty } from "../../components/Empty";
import { PermissionComponent } from "../../components/PermissionComponent";
import { useAuth } from "../../hooks/auth";
const Dashboard = () => {
  const {user} = useAuth();
  const [lastReloading, setLastReloading] = useState(new Date())
  const [render, setRender] = useState(true)
  const [loading, setLoading] = useState(true)
  const [clients, setClients] = useState<IClient[]>([])
  function fetchClients() {
    if(user.type === 'CLIENT') return
    api
    .get<[IClient[], number]>("clients")
    .then((response) => {
      const [data, _] = response.data;
      setClients(data);
    })
    .catch((e) => {
      message.error(e.response.data.message);
    })
    .finally(() => {
      setLoading(false);
    });
  }
  function handleReload() {
    setRender(false)
    setLastReloading(new Date())
  }
  useEffect(()=>{
    if(render){
       fetchClients()
      }else{
        setTimeout(() => {
      
          setRender(true)
        }, 500);
      };
  }, [render])
  useEffect(()=>{
    const timer = setInterval(()=>{handleReload()},120000)
    return ()=>{
      clearInterval(timer)
    }
   
  }, [])
  
  return (
    <Page>
      <header>
        <span>
          Dashboard <BiRevision onClick={handleReload}/>
        </span>
        Última atualização: {lastReloading.toLocaleTimeString([], {timeStyle: 'short'})}
      </header>
      {
        render && (
          <>
     <MessagesCountBar />
      <div className="clients-logs">
        <PermissionComponent type="USER">

        <div className="clients">
          {
            loading
            ? <Load />
            : clients.length
            ? clients.map((client)=> <ClientChart {...client} />)
            : <Empty />
          }
          
         
        </div>
        </PermissionComponent>
        <LastLogs />
      </div>
          </>
        )
      }
    </Page>
  );
};
export { Dashboard };
